import { Injectable, Inject } from '@angular/core';
import { StorageService } from './storage.service';
import {NGXLogger} from "ngx-logger";

/**
 * Session storage service
 * used for persist application data in observable key value pair
 */
@Injectable()
export class SessionStorageService extends StorageService {
  token = "";

  /**
   * Constructor with service injection
   * @param window
   */
  constructor(logger: NGXLogger) {
    super(sessionStorage, logger);
  }
}
